import { useTranslation } from 'react-i18next';
import { CalendarCheck } from 'lucide-react';
import { LanguagePill } from '@/components/chrome/LanguagePill';
import { LogoTile } from './BusinessHeader';
import { cn } from '@/lib/utils';
import type { PublicOrganization } from '../types';

export function MyBookingsLink({ embedded, className }: { embedded: boolean; className?: string }) {
  const { t } = useTranslation('bookingPage');
  return (
    <a
      href="/my-bookings"
      target={embedded ? '_blank' : undefined}
      rel={embedded ? 'noreferrer' : undefined}
      className={cn('h-10 items-center justify-center gap-2 rounded-md border border-line bg-surface px-3 text-[14px] font-medium text-ink hover:border-brand-300', className)}
    >
      <CalendarCheck className="h-4 w-4 text-soft" />
      {t('header.myBookings')}
    </a>
  );
}

export function TopBar({ organization, embedded }: { organization: PublicOrganization; embedded: boolean }) {
  const home = organization.homepage_url;
  const brand = (
    <span className="flex min-w-0 items-center gap-3">
      <LogoTile organization={organization} size="sm" />
      <span className="truncate font-display text-[17px] font-semibold tracking-tight text-ink">{organization.name}</span>
    </span>
  );

  return (
    <header className="border-b border-line bg-surface" data-testid="sloty-header">
      <div className="mx-auto flex h-14 max-w-[1440px] items-center justify-between gap-3 px-4 sm:h-[72px] sm:px-8 lg:px-20">
        {home ? <a href={home} className="min-w-0">{brand}</a> : brand}
        <div className="flex shrink-0 items-center gap-2">
          <LanguagePill availableLanguages={organization.public_locales} />
          {/* On a phone the button sits full width under the bar (BookingPageFrame). */}
          <MyBookingsLink embedded={embedded} className="hidden sm:inline-flex" />
        </div>
      </div>
    </header>
  );
}
